export default __webpack_public_path__ + "static/media/Lato-Semibold.4461d438.ttf";